import React, { Suspense } from 'react';
import { ErrorBoundary } from '@mrkt/features/Platform';

const SidePanel = React.lazy(() =>
  import(/* webpackChunkName: "sidepanel" */ './SidePanel'),
);

export function SidePanelContainer() {
  const fallback = null;

  return (
    <Suspense fallback={fallback}>
      <ErrorBoundary name="s4a-sidepanel" fallback={fallback}>
        <SidePanel />
      </ErrorBoundary>
    </Suspense>
  );
}
